import { render, staticRenderFns } from "./WidgetBaseComponent.vue?vue&type=template&id=1b082be8&scoped=true"
import script from "./WidgetBaseComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetBaseComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WidgetBaseComponent.vue?vue&type=style&index=0&id=1b082be8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b082be8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b082be8')) {
      api.createRecord('1b082be8', component.options)
    } else {
      api.reload('1b082be8', component.options)
    }
    module.hot.accept("./WidgetBaseComponent.vue?vue&type=template&id=1b082be8&scoped=true", function () {
      api.rerender('1b082be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/WidgetBaseComponent.vue"
export default component.exports